export default function (ary) {
  return ary.filter((e) => { return e; });
}
